import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-jk",
  "use": "icon-menu-jk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-jk\"><path d=\"M993.28 295.936c-18.432-7.68-39.936-3.584-54.272 10.752L824.32 421.376V312.32c0-75.776-61.44-137.216-137.216-137.216H137.216C61.44 174.592 0 236.544 0 312.32v399.36c0 75.776 61.44 137.216 137.216 137.216h549.376c75.776 0 137.216-61.44 137.216-137.216v-109.568l114.688 114.688c9.728 9.728 22.528 14.848 35.328 14.848h0.512c27.648 0 49.664-22.528 49.664-50.176V342.528c0-20.48-12.288-38.4-30.72-46.592zM749.056 711.68c0 34.304-28.16 62.464-62.464 62.464H137.216c-34.304 0-62.464-28.16-62.464-62.464V312.32c0-34.304 28.16-62.464 62.464-62.464h549.376c34.304 0 62.464 28.16 62.464 62.464v399.36z m200.192-90.112L839.68 512l109.568-109.568v219.136z\" p-id=\"72508\" /><path d=\"M184.832 363.008m-49.152 0a49.152 49.152 0 1 0 98.304 0 49.152 49.152 0 1 0-98.304 0Z\" p-id=\"72509\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/menu-jk.svg
// module id = DHlW
// module chunks = 20